import "./NotificationsMobile.scss";

import React from "react";
import { compose } from "redux";

import { UrlProvider } from "../../../../../../../api/UrlProvider";
import withAnalysisCategories from "../../../../../../../hocs/withAnalysisCategories";
import withManualStrategies from "../../../../../../../hocs/withManualStrategies";
import withTranslations from "../../../../../../../hocs/withTranslations";
import CheckDouble from "../../../Homepage/assets/icons/check-double.svg";
import Filter from "../../../Homepage/assets/icons/filter.svg";
import Search from "../../../Homepage/assets/icons/search.svg";
import Settings from "../../../Homepage/assets/icons/settings.svg";
import LandingTypography from "../../../Homepage/components/LandingTypography";
import { IconButton } from "../buttons/iconButton";
import NotificationsTabs from "../NotificationsTabs";
import { showModal } from "../../../../../../../lib/react-redux-modal-provider";
import SquaberButton from "../../../../../common/SquaberButton";
import Filters from "../filters/Filters";
import withBottomNavigation from "../../../../../../../hocs/withBottomNavigation";
import withNewNotifications from "../../../../../../../hocs/withNewNotifications";
import getNotificationTypesFromSelectedTab from "../../../../../../../lib/notifications/getNotificationTypesFromSelectedTab";
import Loader from "../../../../../common/Loader";

const NotificationsMobile = ({
  markAsReadAction,
  notificationTypesFilters,
  filters,
  translate,
  locale,
  setValue,
  selectedNotificationsTab: selectedTab,
  setSelectedNotificationsTab,
  globalLoading
}) => {
  const onSelectedTabChange = tab => {
    setSelectedNotificationsTab(tab?.name);
  };

  return (
    <LandingTypography className={"plans"}>
      <aside className="lp_notifications-mobile rounded-lg relative">
        <header className={"flex justify-between align-center px-1 pb-2"}>
          <IconButton
            icon={CheckDouble}
            onClick={() => {
              const notificationTypes = getNotificationTypesFromSelectedTab(
                selectedTab
              );
              markAsReadAction(
                notificationTypes.length > 0 ? { notificationTypes } : {}
              );
            }}
          />
          <IconButton
            icon={Settings}
            to={UrlProvider.getUrl("fe.settingsPageCategory", {
              settingsCategory: "notifications",
              locale
            })}
          />
          <h1
            className={
              "mb-0 text-lg font-semibold font-semibold w-full text-center"
            }
          >
            {translate("Notifications")}
          </h1>
          <IconButton
            icon={Filter}
            childClassName={
              Object.values(notificationTypesFilters).some(
                ({ value }) => value === false
              ) ||
              filters.searchQuery.value ||
              filters.showOnlyUnread.value !== false
                ? "filter-button_has-filters"
                : undefined
            }
            onClick={() => {
              showModal("PageSheet", {
                title: translate("Filter"),
                children: <Filters />,
                bottomChildren: ({ hide }) => {
                  return (
                    <SquaberButton
                      onClick={hide}
                      type="submit"
                      color="primary"
                      style={{ width: "100%", marginTop: "30px" }}
                    >
                      {translate("Close")}
                    </SquaberButton>
                  );
                }
              });
            }}
          />
          <IconButton icon={Search} onClick={() => setValue("search")} />
        </header>
        <NotificationsTabs
          selectedTab={selectedTab}
          onSelectedTabChange={onSelectedTabChange}
        />
        {globalLoading ? (
          <div
            className={
              "absolute top-0 left-0 w-full h-full z-10 flex align-center justify-center"
            }
          >
            <div
              className={
                "absolute top-0 left-0 w-full h-full bg-white opacity-60"
              }
            />
            <div className={"relative z-10"}>
              <Loader small />
            </div>
          </div>
        ) : null}
      </aside>
    </LandingTypography>
  );
};

export default compose(
  withTranslations,
  withManualStrategies,
  withAnalysisCategories,
  withNewNotifications,
  withBottomNavigation("navState")
)(NotificationsMobile);
